const convertBlobToBase64 = (blob) => {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      resolve(reader.result);
    };
    reader.readAsDataURL(blob);
  });
};

const fileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = function (e) {
      // Extract base64 data (remove data:image/png;base64, prefix)
      const base64Data = e.target.result.split(',')[1];
      const fileType = file.type.split('/')[1];
      resolve({
        base64: base64Data,
        fileType: fileType,
        fileName: file.name,
        fileSize: file.size
      });
    };

    reader.onerror = function (error) {
      reject(error);
    };

    reader.readAsDataURL(file);
  });
};

export { fileToBase64, convertBlobToBase64 };
